"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var postcode_regexes_1 = require("./postcode-regexes");

exports.postcodeValidator = function (postcode, country) {
  if (!postcode_regexes_1.POSTCODE_REGEXES.has(country)) {
    // throw Error if country code is unrecognised
    throw Error("Invalid country code: ".concat(country));
  }

  return postcode_regexes_1.POSTCODE_REGEXES.get(country).test(postcode);
};

exports.postcodeValidatorExistsForCountry = function (country) {
  return postcode_regexes_1.POSTCODE_REGEXES.has(country);
};